// libs
import moment from 'moment'
// constants
import { STATUS_FILTERS, TIME_FRAME_FILTERS } from 'constants/home'
// utils
import { get, isEmpty } from 'lodash'

export const createFilters = ({ statusFilter, timeFrameFilter, description, usersFilter, startPeriod, endPeriod }) => ({
  byStatus: (task: any) => {
    switch (statusFilter) {
      case STATUS_FILTERS.OPEN:
        return task.isOpen
      case STATUS_FILTERS.OVERDUE:
        return task.isOverdue && task.isOpen
      case STATUS_FILTERS.ALL:
        return true
      default:
        return false
    }
  },
  byTimeFrame: (task: any) =>
    timeFrameFilter === TIME_FRAME_FILTERS.CUSTOM
      ? moment(task.dueDate).isSameOrAfter(moment(startPeriod), 'day') &&
        moment(task.dueDate).isSameOrBefore(moment(endPeriod), 'day')
      : true,
  byDescription: (task: any) =>
    description ? task.description.toLowerCase().includes(description.toLowerCase()) : true,
  byAssignedUsers: (task: any) =>
    !isEmpty(usersFilter)
      ? task.assignedPersons.some((assignedPerson) =>
          usersFilter.some((member) => member.id === get(assignedPerson, 'id'))
        )
      : true
})
